import Axios from "axios";
// import router from "./../../router/index";
import store from "./../index";
// state
const state = {
  responseMsg: "",
  responseStatus: ""
};

// getters
const getters = {};

// actions
const actions = {
  async loginUser({ commit }: any, login: any) {
    await Axios.get("/sanctum/csrf-cookie").then(async () => {
      await Axios.post("/login", {
        email: login.email,
        password: login.password,
        remember: login.remember ? true : null
      })
        .then(() => {
          commit("UPDATE_RESPONSE_MSG", "Usuário logado com sucesso");
          commit("UPDATE_RESPONSE_STATUS", "success");
          store.dispatch("appStore/checkIfUserIsLoggedIn");
          store.dispatch("appStore/setLoadingStatus", true);
        })
        .catch((error) => {
          const errorMSG = error.response.data.errors.email[0];
          commit("UPDATE_RESPONSE_MSG", errorMSG);
          commit("UPDATE_RESPONSE_STATUS", "error");
        });
    });
  },
  async resetPassword({ commit }: any, email: any) {
    await Axios.get("/sanctum/csrf-cookie").then(async () => {
      await Axios.post("/password/email", {
        email
      })
        .then((response) => {
          commit("UPDATE_RESPONSE_MSG", response.data.message);
          commit("UPDATE_RESPONSE_STATUS", "success");
        })
        .catch((error) => {
          const errorMSG = error.response.data.message;
          commit("UPDATE_RESPONSE_MSG", errorMSG);
          commit("UPDATE_RESPONSE_STATUS", "error");
        });
    });
  },
  async setNewPassword({ commit }: any, resetData: any) {
    await Axios.get("/sanctum/csrf-cookie").then(async () => {
      await Axios.post("/password/reset", {
        token: resetData.token,
        email: resetData.email,
        password: resetData.password,
        // eslint-disable-next-line @typescript-eslint/camelcase
        password_confirmation: resetData.confirm
      })
        .then((response) => {
          commit("UPDATE_RESPONSE_MSG", response.data.msg);
          commit("UPDATE_RESPONSE_STATUS", "success");
          store.dispatch("appStore/checkIfUserIsLoggedIn");
        })
        .catch((error) => {
          const errorMSG = error.response.data.msg;
          commit("UPDATE_RESPONSE_MSG", errorMSG);
          commit("UPDATE_RESPONSE_STATUS", "error");
        });
    });
  },
  async registerNewUser({ commit }: any, userData: any) {
    let data: any[] = commit;
    return new Promise((resolve) => {
      Axios.get("/sanctum/csrf-cookie").then(async () => {
        await Axios.post("/api/v1/register", {
          data: userData
        })
          .then((response) => {
            data = response.data;
          })
          .catch(() => {
            //
          })
          .finally(() => {
            resolve(data);
          });
      });
    });
  },
  logout: function({ commit }: any) {
    commit("appStore/SET_LOADING_STATUS", true, { root: true });
    Axios.post("/logout")
      .then(() => {
        store.dispatch("appStore/logoutUser");
      })
      .catch(() => {
        //
      })
      .finally(() => {
        commit("appStore/SET_LOADING_STATUS", false, { root: true });
      });
  }
};

// mutations
const mutations = {
  UPDATE_RESPONSE_MSG(state: any, msg: string) {
    state.responseMsg = msg;
  },
  UPDATE_RESPONSE_STATUS(state: any, status: string) {
    state.responseStatus = status;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
